import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 6.7 13 5c.5-.2 1 .1 1 .6v4.6c0 .5-.5.8-1 .6l-3-1.6M3.3 12h5.4c.7 0 1.3-.6 1.3-1.3V5.3C10 4.6 9.4 4 8.7 4H3.3C2.6 4 2 4.6 2 5.3v5.4c0 .7.6 1.3 1.3 1.3Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }